import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge, IconButton, useTheme } from "@mui/material";
import type { RefObject } from "react";

type Props = {
  colorVariant: "light" | "dark";
  badgeRef: RefObject<HTMLDivElement | null>;
  onPopupOpenRequested?: () => void;
  notificationsCount: number;
};

export const NotificationsBadge = ({
  colorVariant,
  badgeRef,
  onPopupOpenRequested,
  notificationsCount,
}: Props) => {
  const theme = useTheme();

  const notificationsLabel =
    notificationsCount > 9 ? "9+" : notificationsCount || undefined;

  return (
    <Badge
      ref={badgeRef}
      color="error"
      badgeContent={notificationsLabel}
      sx={{ "& .MuiBadge-badge": { right: 6, top: 6 } }}
    >
      <IconButton
        onClick={onPopupOpenRequested}
        sx={{
          width: 40,
          height: 40,
          bgcolor: theme.palette.headerWidget[colorVariant].background,
          color: theme.palette.headerWidget[colorVariant].text,
        }}
      >
        <NotificationsIcon fontSize="small" />
      </IconButton>
    </Badge>
  );
};
